import {
  CheckCircleOutlineRoundedIcon,
  CancelOutlinedIcon,
  Flex,
  RemoveCircleOutlineOutlinedIcon,
} from '@shared/components';

import { QuestionReviewResultVerdict } from '../../providers';

interface ReviewResultLabelProps {
  verdict?: QuestionReviewResultVerdict | null;
}

function getReviewResultLabelVerdict(verdict: ReviewResultLabelProps['verdict']) {
  switch (verdict) {
    case QuestionReviewResultVerdict.Approved:
      return {
        icon: <CheckCircleOutlineRoundedIcon color='success' fontSize='small' />,
        labelText: 'เห็นด้วย',
      };
    case QuestionReviewResultVerdict.Rejected:
      return {
        icon: <CancelOutlinedIcon color='error' fontSize='small' />,
        labelText: 'ไม่เห็นด้วย',
      };
    default:
      return {
        icon: (
          <RemoveCircleOutlineOutlinedIcon
            fontSize='small'
            sx={{
              color: (theme) => theme.palette.grey[400],
            }}
          />
        ),
        labelText: 'รอการทบทวน',
      };
  }
}

export default function ReviewResultLabel(props: Readonly<ReviewResultLabelProps>) {
  const { verdict } = props;

  const { icon, labelText } = getReviewResultLabelVerdict(verdict);

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(2), alignItems: 'center' })}>
      {icon} {labelText}
    </Flex>
  );
}
